import { ContentSuggestionParams, SuggestionsType } from '../types';
import { useContentSuggestions } from './useContentSuggestions';
import { useLabels } from './useLabels';

export const useSuggestedLabel = ({
    searchInput,
    showOnlyFilterSuggestions,
    hasActiveSearch,
}: {
    searchInput?: string;
    showOnlyFilterSuggestions: boolean;
    hasActiveSearch: boolean;
}) => {
    const { labels, isLoading, hasError } = useLabels();

    const suggestions = useContentSuggestions({
        contents: labels,
        isLoading,
        hasError,
        searchInput,
        showOnlyFilterSuggestions,
        hasActiveSearch,
        suggestionParams: ContentSuggestionParams.suggestedlabels,
        suggestionType: SuggestionsType.Label,
    });

    return suggestions;
};
